// extracted by mini-css-extract-plugin
export default {"Wrapper":"Attributes_Wrapper__hi81v","Container":"Attributes_Container__YGE6k","Header":"Attributes_Header__-LCBk","Item":"Attributes_Item__KcHoE"};